import { TypeChecker } from '@attain-apps/type-guards'

import type { Feature } from './feature'

/** Minimum length for a valid prompt (after trimming).*/
const MIN_PROMPT_LENGTH = 10

/** Selectors for the mosaic dev pages assistant feature. */
export class Selectors {
  /** The user's prompt text when available as a string, otherwise undefined. */
  public readonly prompt
  /** Indicates whether the prompt input dialog should be displayed. */
  public readonly presentPrompt
  /**
   * Indicates whether page generation can be triggered. Returns true when the
   * prompt is valid (defined and has more than {@link MIN_PROMPT_LENGTH}
   * characters).
   */
  public readonly canGenerate
  /** Indicates whether page generation is currently in progress. */
  public readonly isGenerating
  /** Error message from page generation when available, otherwise undefined. */
  public readonly generatingError
  /** File attached to provide data to the assistant when available, otherwise undefined. */
  public readonly file

  constructor(feature: Feature) {
    this.prompt = feature.state.project(s => s.prompt)
    this.presentPrompt = feature.state.project(s => s.presentPrompt)
    this.canGenerate = this.prompt.project(
      prompt =>
        prompt !== undefined && prompt.trim().length > MIN_PROMPT_LENGTH,
    )
    this.isGenerating = feature.state.project(
      s => s.generating?.loading === true,
    )
    this.generatingError = feature.state.project(s => {
      const err = s.generating?.error
      return TypeChecker.isString(err)
        ? err
        : err instanceof Error
          ? err.message
          : undefined
    })

    this.file = feature.state.project(s => s.file)
  }
}
